module.exports = __webpack_public_path__ + "img/delete_column.87c95ca7.svg";